module.exports = __webpack_public_path__ + "img/arrow-left.89fea599.svg";